"use strict";

exports.__esModule = true;
exports.DeviceListScreenPlantTwin = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactRouterDom = require("react-router-dom");
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _Core = require("../../Core");
var _DeviceList = require("../DeviceList");
var _MasterDetailView = require("../../Core/MasterDetailView");
var _System = require("../../../System");
var _UpdateDeviceScreenPlantTwin = require("../UpdateDeviceScreenPlantTwin");
var _Theme = require("../../Theme");
var _CreateDeviceScreenPlantTwin = require("../CreateDeviceScreenPlantTwin");
var _DeviceTypeListContext = require("../DeviceTypeListContext");
var _DeviceListContext = require("../DeviceListContext");
var _DeviceTagListContext = require("../DeviceTagListContext");
var _customHooks = require("../../../Utils/customHooks");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var DetailWrapper = _styledComponents["default"].div.withConfig({
  displayName: "DeviceListScreenPlantTwin__DetailWrapper",
  componentId: "sc-1aa4uto-0"
})(["position:absolute;opacity:0;top:0;z-index:-100;width:100%;height:100%;background:", ";transition:opacity 0.25s ease-in,left 0.25s ease-in,box-shadow 0.5s ease-in,z-index 0.25s ease-in;&.hasExpandedDetail{box-shadow:-20px 2px 35px -19px rgba(0,0,0,0.3);z-index:3;opacity:1;overflow:hidden;}"], (0, _Theme.val)("background"));
var ContainerWrapper = _styledComponents["default"].div.withConfig({
  displayName: "DeviceListScreenPlantTwin__ContainerWrapper",
  componentId: "sc-1aa4uto-1"
})(["overflow-x:hidden;flex:1;position:relative;height:100%;"]);
var MasterWrapper = _styledComponents["default"].div.withConfig({
  displayName: "DeviceListScreenPlantTwin__MasterWrapper",
  componentId: "sc-1aa4uto-2"
})(["position:relative;z-index:2;opacity:1;transition:opacity 0.25s ease-in;&.hasExpandedDetail{display:none;}"]);
var DeviceListScreenPlantTwin = exports.DeviceListScreenPlantTwin = (0, _reactRouterCompat.withRouter)(function (props) {
  var devices = _react["default"].useContext(_DeviceListContext.AllDeviceListContext);
  var _useState = (0, _react.useState)(devices),
    filteredDeviceList = _useState[0],
    setFilteredDeviceList = _useState[1];
  var match = props.match,
    location = props.location,
    searchString = props.searchString,
    setNumDevicesMatched = props.setNumDevicesMatched;
  var id = match.params.id;
  var _useNodeBoundingRect = (0, _customHooks.useNodeBoundingRect)(),
    width = _useNodeBoundingRect.width,
    height = _useNodeBoundingRect.height,
    ref = _useNodeBoundingRect.ref;
  (0, _react.useEffect)(function () {
    var lowercaseSearchString = searchString.toLowerCase();
    setFilteredDeviceList(filterDeviceByText(devices, lowercaseSearchString, setNumDevicesMatched));
  }, [searchString, devices]);
  var showCreateView = location.pathname === (0, _System.getScreenPath)("CreateDevicePlantTwin");
  var showDetailView = id || showCreateView ? "true" : undefined;
  function handleSelect(selected) {
    var history = props.history;
    if (selected === id || selected !== undefined) {
      return;
    }
    history.push((0, _System.getScreenLocation)("DeviceListPlantTwin"));
  }
  return /*#__PURE__*/_react["default"].createElement(_DeviceTypeListContext.DeviceTypeListLoader, null, function (_ref) {
    var data = _ref.data,
      error = _ref.error;
    if (!error && !data) {
      return /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null);
    }
    return /*#__PURE__*/_react["default"].createElement(_DeviceTypeListContext.DeviceTypeListContext.Provider, {
      value: data
    }, /*#__PURE__*/_react["default"].createElement(_DeviceTagListContext.DeviceTagListLoader, null, function (_ref2) {
      var deviceTagList = _ref2.data,
        tagError = _ref2.error;
      if (!tagError && !deviceTagList) {
        return /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null);
      }
      return /*#__PURE__*/_react["default"].createElement(_DeviceTagListContext.DeviceTagListContext.Provider, {
        value: deviceTagList
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          height: "calc(100vh - 96px)",
          width: "100%"
        },
        ref: ref
      }, /*#__PURE__*/_react["default"].createElement(_MasterDetailView.MasterDetailView, {
        selected: showDetailView,
        onSelect: handleSelect,
        renderMaster: function renderMaster() {
          return /*#__PURE__*/_react["default"].createElement(_DeviceList.DeviceList, {
            items: filteredDeviceList,
            height: height,
            width: width,
            screenName: "UpdateDevicePlantTwin"
          });
        },
        renderDetail: function renderDetail() {
          return /*#__PURE__*/_react["default"].createElement(_reactRouterCompat.RootRoutes, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
            path: (0, _System.getScreenPath)("UpdateDevicePlantTwin"),
            element: /*#__PURE__*/_react["default"].createElement(_reactRouterCompat.CompatRoute, {
              component: _UpdateDeviceScreenPlantTwin.UpdateDeviceScreenPlantTwin
            })
          }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
            path: (0, _System.getScreenPath)("CreateDevicePlantTwin"),
            element: /*#__PURE__*/_react["default"].createElement(_reactRouterCompat.CompatRoute, {
              component: _CreateDeviceScreenPlantTwin.CreateDeviceScreenPlantTwin
            })
          }));
        },
        ContainerWrapper: ContainerWrapper,
        MasterWrapper: MasterWrapper,
        DetailWrapper: DetailWrapper
      })));
    }));
  });
});
function filterDeviceByText(deviceList, searchString, setNumDevicesMatched) {
  var listToReturn;
  if (!searchString) {
    listToReturn = deviceList;
  } else {
    listToReturn = deviceList.filter(function (device) {
      return device.name.toLowerCase().includes(searchString);
    });
  }
  setNumDevicesMatched(listToReturn.length);
  return listToReturn;
}